// SPDX-FileCopyrightText: 2026 Ben Richardson
// SPDX-License-Identifier: AGPL-3.0-or-later

export const num = (n: number): string =>
  Number.isFinite(n) ? n.toLocaleString('en-AU') : '—';

export const dec = (n: number, places = 1): string =>
  Number.isFinite(n) ? n.toFixed(places) : '—';

export const pct = (n: number, places = 1): string =>
  Number.isFinite(n) ? `${(n * 100).toFixed(places)}%` : '—';

export const money = (n: number): string =>
  Number.isFinite(n) ? `$${Math.round(n).toLocaleString('en-AU')}` : '—';

const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

/** "2024-01-26" -> "26 January 2024". Dates are the register's own strings. */
export function longDate(iso: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso ?? '');
  if (!m) return iso ?? '—';
  return `${Number(m[3])} ${MONTHS[Number(m[2]) - 1]} ${m[1]}`;
}

/**
 * TWO ESCAPING FUNCTIONS, deliberately separate.
 *
 * `setAttribute` takes RAW newlines; a string built for `innerHTML` needs them
 * as `&#10;`. Using the wrong one renders a literal "&#10;" in the tooltip.
 */
export function escapeHtml(s: string): string {
  return String(s ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/** For a data-tip written into an HTML string: newlines must be entities. */
export function tipAttr(s: string): string {
  return escapeHtml(s).replace(/\n/g, '&#10;');
}

/** For el.setAttribute('data-tip', …): raw newlines, no entity encoding. */
export function tipValue(s: string): string {
  return String(s ?? '');
}

/** Case-insensitive, accent-insensitive fold for name search. */
export function fold(s: string): string {
  return String(s ?? '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase();
}
